import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
  Divider,
} from "@mui/material";
import { useApi } from "../../utils/api";
import { ENDPOINTS } from "../../config/endpoints";

const EmployeeSalaryTab = ({ personel }) => {
  const http = useApi();

  const [loading, setLoading] = useState(false);
  const [puantaj, setPuantaj] = useState(null);
  const [error, setError] = useState("");

  const [yil, setYil] = useState(new Date().getFullYear());
  const [ay, setAy] = useState(new Date().getMonth() + 1);

  /* ================= PUANTAJ HESAPLAMA ================= */
  const hesaplaPuantajOzet = () => {
    if (!puantaj?.puantajlar) {
      return { ders: 0, nobet: 0, fazla: 0 };
    }

    let toplamDers = 0;
    let toplamNobet = 0;
    let toplamFazla = 0;

    puantaj.puantajlar.forEach((p) => {
      toplamDers += Number(p.ders || 0);
      toplamNobet += Number(p.nobet || 0);
      toplamFazla += Number(p.fazla || 0);
    });

    return {
      // haftalık 20 saati aşan ders
      ders: Math.max(0, toplamDers - 20),
      nobet: toplamNobet,
      fazla: toplamFazla,
    };
  };

  const { ders, nobet, fazla } = hesaplaPuantajOzet();

  /* ================= DATA ÇEKME ================= */
  useEffect(() => {
    if (!personel?.id) return;

    setLoading(true);
    setError("");

    http
      .get(`${ENDPOINTS.PUANTAJ.PERSONEL}/${personel.id}?yil=${yil}&ay=${ay}`)
      .then((data) => {
        const puantajData = Array.isArray(data) ? data[0] : data;
        setPuantaj(puantajData || null);
      })
      .catch((err) =>
        setError(err.message || "Puantaj bilgisi alınamadı")
      )
      .finally(() => setLoading(false));
  }, [personel, yil, ay, http]);

  /* ================= LOADING / ERROR ================= */
  if (loading)
    return (
      <Box display="flex" justifyContent="center" py={4}>
        <CircularProgress />
      </Box>
    );

  if (error)
    return (
      <Typography color="error" align="center" py={2}>
        {error}
      </Typography>
    );

  /* ================= UI ================= */
  return (
    <Paper
      elevation={3}
      sx={{
        p: 3,
        borderRadius: 2,
        maxWidth: 450,
        mx: "auto",
        bgcolor: "#f9fafb",
      }}
    >
      <Box mb={2} textAlign="center">
        <Typography variant="h6" fontWeight={600}>
          {personel?.ad} {personel?.soyad}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Ücret Bilgisi
        </Typography>
      </Box>

      {/* Ay / Yıl */}
      <Box display="flex" gap={2} mb={2} justifyContent="center">
        <FormControl size="small">
          <InputLabel>Ay</InputLabel>
          <Select value={ay} onChange={(e) => setAy(Number(e.target.value))}>
            {Array.from({ length: 12 }, (_, i) => (
              <MenuItem key={i} value={i + 1}>
                {i + 1}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small">
          <InputLabel>Yıl</InputLabel>
          <Select value={yil} onChange={(e) => setYil(Number(e.target.value))}>
            {[2024, 2025, 2026].map((y) => (
              <MenuItem key={y} value={y}>
                {y}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Divider sx={{ mb: 2 }} />

      {/* ===== ÜCRET BİLGİLERİ ===== */}
      <Typography variant="subtitle2" color="text.secondary" mb={1}>
        Ücret Bilgileri
      </Typography>

      <Box display="flex" justifyContent="space-between">
        <Typography variant="body2" color="text.secondary">
          Maaş
        </Typography>
        <Typography variant="body2">
          {parseFloat(personel?.maas || 0).toFixed(2) - 0} ₺
        </Typography>
      </Box>

      <Box display="flex" justifyContent="space-between">
        <Typography variant="body2" color="text.secondary">
          Saatlik Ücret
        </Typography>
        <Typography variant="body2">
          {parseFloat(personel?.saatlik_ucret || 0).toFixed(2) - 0} ₺
        </Typography>
      </Box>

      <Divider sx={{ my: 2 }} />

      {/* PUANTAJ ÖZET */}
      <Typography variant="subtitle2" color="text.secondary" mb={1}>
        Performans Bilgileri
      </Typography>
      <Box display="flex" justifyContent="space-between">
        <Typography variant="body2" color="text.secondary">
          Ders (20 saat üstü)
        </Typography>
        <Typography variant="body2">{parseFloat(ders.toFixed(1))} saat</Typography>
      </Box>

      <Box display="flex" justifyContent="space-between">
        <Typography variant="body2" color="text.secondary">
          Nöbet
        </Typography>
        <Typography variant="body2">{nobet.toFixed(1) - 0} saat</Typography>
      </Box>

      <Box display="flex" justifyContent="space-between">
        <Typography variant="body2" color="text.secondary">
          Fazla Saat
        </Typography>
        <Typography variant="body2">{fazla.toFixed(1) - 0} saat</Typography>
      </Box>
    </Paper>
  );
};

export default EmployeeSalaryTab;
